<template>
  <FullScreenModal :open="open" @close="closeModal">
    <div>
      <h1 class="flex items-center justify-center text-lg sm:text-2xl text-center font-bold">Ajout de la facture</h1>
      <CompensationValueAlert
        v-if="currentClaim.compensationValue"
        :compensation-value="currentClaim.compensationValue"
        class="mt-3"
      />
      <p class="mt-2 sm:mt-4 text-sm text-gray-600">
        Téléversez la facture finale et détaillez les coûts pour clôturer le sinistre.
      </p>
    </div>
    <FormField
      class="mt-3 sm:mt-5"
      id="file_input"
      v-model="file"
      required
      type="file"
      label="Facture"
      field-class="block w-full text-sm text-gray-700 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 dark:text-gray-400 focus:outline-hidden dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400"
      name="invoice_upload"
    />
    <ExtractionStatus
      :extracting="extracting"
      :extraction-error="extractionError"
      :extraction-success="extractionSuccess"
      @dismiss-success="extractionSuccess = false"
    />
    <UploadApprovalAlerts class="mt-3" :file="file" document-kind="invoice" @update:analyzing="analyzing = $event" />
    <div class="border-t border-gray-200 pt-5 sm:pt-7 mt-5 sm:mt-7">
      <CostItems :initial-items="costItems" @updated-items="(items) => (costItems = items)" />
      <PricingDetails :claim="currentClaim" :costItems="costItems" />
    </div>
    <NewProductForm
      v-if="replacementProductRequired"
      v-model="replacementProduct"
      :price-band-max="currentClaim?.priceBandMax"
      class="border-t border-gray-200 pt-5 sm:pt-7 mt-5 sm:mt-7"
      @update:valid="replacementProductValid = $event"
    />
    <div v-if="file && costItems && costItems.length > 0" class="flex justify-center">
      <GenericButton
        class="mt-5"
        :disabled="submitting || analyzing || (replacementProductRequired && !replacementProductValid)"
        @click="send"
      >
        Envoyer la facture
      </GenericButton>
    </div>
  </FullScreenModal>
</template>
<script>
import {
  FullScreenModal,
  GenericButton,
  CostItems,
  PricingDetails,
  CompensationValueAlert,
  FormField,
  ExtractionStatus,
  toCamelCase,
} from "@estaly/ui";
import { extractCostItemsMixin } from "@estaly/ui";
import { mapActions, mapGetters, mapState } from "vuex";
import NewProductForm from "@/components/claim/details/action/NewProductForm.vue";
import UploadApprovalAlerts from "@/components/claim/details/invoice/UploadApprovalAlerts.vue";
import { emptyReplacementProduct, replacementProductFromAnalysis } from "@/utils/replacement_capture";
export default {
  components: {
    FormField,
    CompensationValueAlert,
    CostItems,
    PricingDetails,
    GenericButton,
    FullScreenModal,
    ExtractionStatus,
    NewProductForm,
    UploadApprovalAlerts,
  },
  mixins: [extractCostItemsMixin],
  props: ["open"],
  data: () => {
    return {
      file: null,
      costItems: null,
      replacementProduct: emptyReplacementProduct(),
      replacementProductValid: false,
      submitting: false,
      analyzing: false,
    };
  },

  computed: {
    ...mapState("claims", ["currentClaim"]),
    ...mapGetters("claims", ["shouldCaptureReplacementProduct"]),

    // La facture déposée depuis le BO est approuvée d'office : le produit de remplacement doit être validé ici.
    replacementProductRequired() {
      return this.shouldCaptureReplacementProduct(this.currentClaim);
    },
  },

  watch: {
    async file(newFile) {
      if (!newFile || !this.replacementProductRequired) return;

      const productBeforeExtraction = this.replacementProduct;
      const response = await this.extractReplacementProduct({ file: newFile });
      const extractedProduct = response?.data?.new_product;
      // Le préremplissage ne doit pas écraser une saisie faite pendant l'extraction.
      if (newFile !== this.file || !extractedProduct || this.replacementProduct !== productBeforeExtraction) return;

      this.replacementProduct = replacementProductFromAnalysis(toCamelCase(extractedProduct));
    },
  },

  methods: {
    ...mapActions("claims", ["uploadInvoice", "extractCostItems", "extractReplacementProduct"]),
    ...mapActions("notifications", ["notify"]),

    async send() {
      this.submitting = true;
      const { success } = await this.uploadInvoice({
        costItems: this.costItems,
        file: this.file,
        replacementProduct: this.replacementProductRequired ? this.replacementProduct : null,
      });
      this.submitting = false;
      if (success) this.closeModal();
    },
    closeModal() {
      this.$emit("close");
      this.file = null;
      this.costItems = null;
      this.replacementProduct = emptyReplacementProduct();
    },
  },
};
</script>
